// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"4d672e5f","395":"5d49d879"}[chunkId] + ".chunk.js";
};